import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar la voz que busca aprobación",
    opening: localizedGenderNode(
      [
      "Hoy no intento dejar de buscar aprobación. Noto cuándo aparece."
    ],
      [
      "Hoy no intento dejar de buscar aprobación. Noto cuándo aparece."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es la necesidad de aprobación. No soy yo.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esta es la necesidad de aprobación. No soy yo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué momento de hoy me importa más lo que piensen de mí?\n[Escribe aquí]",
      "2. ¿Qué miedo hay debajo? (rechazo / vergüenza / no pertenecer)\n[Escribe aquí]",
      "3. ¿Dónde siento esta necesidad en el cuerpo?\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué momento de hoy me importa más lo que piensen de mí?\n[Escribe aquí]",
      "2. ¿Qué miedo hay debajo? (rechazo / vergüenza / no pertenecer)\n[Escribe aquí]",
      "3. ¿Dónde siento esta necesidad en el cuerpo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Buscar aprobación es un mecanismo de protección, no una debilidad.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Buscar aprobación es un mecanismo de protección, no una debilidad.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + “Noté la necesidad, no actué.”",
      "Una vez hoy: una respiración + “Noté la necesidad, no actué.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hecho vs. imaginación (“¿Qué pasará realmente?”)",
    opening: localizedGenderNode(
      [
      "Hoy separo el miedo de la realidad."
    ],
      [
      "Hoy separo el miedo de la realidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué temo que digan de mí?\n[Escribe aquí]",
      "2. ¿Qué pruebas reales existen?\n[Escribe aquí]",
      "3. ¿Qué es más probable que ocurra en realidad?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué temo que digan de mí?\n[Escribe aquí]",
      "2. ¿Qué pruebas reales existen?\n[Escribe aquí]",
      "3. ¿Qué es más probable que ocurra en realidad?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La mente exagera para proteger, no para ser precisa.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "La mente exagera para proteger, no para ser precisa.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece “¿qué pensarán?” pregunto: “¿Hay pruebas?”",
      "Cuando aparece “¿qué pensarán?” pregunto: “¿Hay pruebas?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El precio de vivir para la aprobación",
    opening: localizedGenderNode(
      [
      "Hoy veo lo que esto me cuesta."
    ],
      [
      "Hoy veo lo que esto me cuesta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde actúo distinto para agradar?\n[Escribe aquí]",
      "2. ¿Qué pierdo de mí cuando lo hago?\n[Escribe aquí]",
      "3. ¿Cómo se siente mi cuerpo después de complacer?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde actúo distinto para agradar?\n[Escribe aquí]",
      "2. ¿Qué pierdo de mí cuando lo hago?\n[Escribe aquí]",
      "3. ¿Cómo se siente mi cuerpo después de complacer?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La aprobación externa da alivio momentáneo y cuesta identidad.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "La aprobación externa da alivio momentáneo y cuesta identidad.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy noto que complazco — sin corregirlo.",
      "Una vez hoy noto que complazco — sin corregirlo."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "De dónde viene esto",
    opening: localizedGenderNode(
      [
      "Hoy identifico el origen, sin culpar."
    ],
      [
      "Hoy identifico el origen, sin culpar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo aprendí que necesitaba aprobación para estar bien?\n[Escribe aquí]",
      "2. ¿Quién me enseñó esto — con palabras o actos?\n[Escribe aquí]",
      "3. ¿Qué necesitaba entonces y no recibí?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo aprendí que necesitaba aprobación para estar bien?\n[Escribe aquí]",
      "2. ¿Quién me enseñó esto — con palabras o actos?\n[Escribe aquí]",
      "3. ¿Qué necesitaba entonces y no recibí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Lo aprendido puede reaprenderse.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Lo aprendido puede reaprenderse.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una frase a mi yo joven: “No tenías que demostrar nada.”",
      "Una frase a mi yo joven: “No tenías que demostrar nada.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Detectar el complacer en tiempo real",
    opening: localizedGenderNode(
      [
      "Hoy me detengo antes de decir “sí”."
    ],
      [
      "Hoy me detengo antes de decir “sí”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde me cuesta más decir “no”?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si rechazo?\n[Escribe aquí]",
      "3. ¿Qué me pasa si sigo diciendo “sí” a costa mía?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde me cuesta más decir “no”?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si rechazo?\n[Escribe aquí]",
      "3. ¿Qué me pasa si sigo diciendo “sí” a costa mía?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Antes del “sí” a otros, está el “sí” a mí.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Antes del “sí” a otros, está el “sí” a mí.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Antes de responder: una respiración + “¿Qué es correcto para mí?”",
      "Antes de responder: una respiración + “¿Qué es correcto para mí?”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Aprobación vs. conexión real",
    opening: localizedGenderNode(
      [
      "Hoy distingo amor de complacencia."
    ],
      [
      "Hoy distingo amor de complacencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién me siento conectado sin impresionar?\n[Escribe aquí]",
      "2. ¿Cómo se siente en el cuerpo ser simplemente yo?\n[Escribe aquí]",
      "3. ¿Qué me enseña esto sobre las relaciones?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién me siento conectado sin impresionar?\n[Escribe aquí]",
      "2. ¿Cómo se siente en el cuerpo ser simplemente yo?\n[Escribe aquí]",
      "3. ¿Qué me enseña esto sobre las relaciones?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La conexión real no requiere actuación.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "La conexión real no requiere actuación.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Elijo a una persona para simplemente estar.",
      "Elijo a una persona para simplemente estar."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un pequeño experimento (Conducta)",
    opening: localizedGenderNode(
      [
      "Hoy hago algo pequeño sin revisar reacciones."
    ],
      [
      "Hoy hago algo pequeño sin revisar reacciones."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué acción evito por la opinión de otros?\n[Escribe aquí]",
      "2. ¿Cuál es su versión del 10%?\n[Escribe aquí]",
      "3. ¿Cómo quiero sentirme después?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué acción evito por la opinión de otros?\n[Escribe aquí]",
      "2. ¿Cuál es su versión del 10%?\n[Escribe aquí]",
      "3. ¿Cómo quiero sentirme después?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El coraje crece con acciones pequeñas.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "El coraje crece con acciones pequeñas.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Hago mi 10% y no reviso qué dijeron.",
      "Hago mi 10% y no reviso qué dijeron."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Permitir la incomodidad (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy me quedo con la incomodidad sin correr a la aprobación."
    ],
      [
      "Hoy me quedo con la incomodidad sin correr a la aprobación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué sensación surge cuando no hay aprobación?\n[Escribe aquí]",
      "2. Práctica de un minuto: dejo que la sensación esté. ¿Qué pasa?\n[Escribe aquí]",
      "3. ¿Qué aprendí sobre la ola?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué sensación surge cuando no hay aprobación?\n[Escribe aquí]",
      "2. Práctica de un minuto: dejo que la sensación esté. ¿Qué pasa?\n[Escribe aquí]",
      "3. ¿Qué aprendí sobre la ola?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La incomodidad es una ola, no un peligro.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "La incomodidad es una ola, no un peligro.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Un minuto solamente. Constancia > fuerza.",
      "Un minuto solamente. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "El crítico interno cuando falta aprobación",
    opening: localizedGenderNode(
      [
      "Hoy noto cómo el crítico reemplaza la aprobación externa."
    ],
      [
      "Hoy noto cómo el crítico reemplaza la aprobación externa."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué dice el crítico cuando no hay aprobación?\n[Escribe aquí]",
      "2. ¿Cómo hablaría a un amigo cercano?\n[Escribe aquí]",
      "3. ¿Qué frase amable elijo hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué dice el crítico cuando no hay aprobación?\n[Escribe aquí]",
      "2. ¿Cómo hablaría a un amigo cercano?\n[Escribe aquí]",
      "3. ¿Qué frase amable elijo hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito castigarme cuando otros callan.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "No necesito castigarme cuando otros callan.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece el crítico — una frase amable.",
      "Cuando aparece el crítico — una frase amable."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Un límite frente al “qué pensarán”",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite interno."
    ],
      [
      "Hoy pongo un límite interno."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde “qué pensarán” me controla más?\n[Escribe aquí]",
      "2. ¿Qué pequeño límite pongo esta semana?\n[Escribe aquí]",
      "3. ¿Qué miedo rodea este límite?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde “qué pensarán” me controla más?\n[Escribe aquí]",
      "2. ¿Qué pequeño límite pongo esta semana?\n[Escribe aquí]",
      "3. ¿Qué miedo rodea este límite?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite no aleja el amor — me protege.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Un límite no aleja el amor — me protege.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una acción que honre el límite.",
      "Una acción que honre el límite."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Valor propio sin público",
    opening: localizedGenderNode(
      [
      "Hoy pregunto quién soy cuando nadie mira."
    ],
      [
      "Hoy pregunto quién soy cuando nadie mira."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué me gusta de mí sin depender de opiniones?\n[Escribe aquí]",
      "2. ¿Dónde me siento estable incluso solo/a?\n[Escribe aquí]",
      "3. ¿Cómo se siente eso en el cuerpo?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué me gusta de mí sin depender de opiniones?\n[Escribe aquí]",
      "2. ¿Dónde me siento estable incluso solo/a?\n[Escribe aquí]",
      "3. ¿Cómo se siente eso en el cuerpo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi valor no depende de espectadores.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Mi valor no depende de espectadores.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Un tiempo corto a solas — sin publicar, sin compartir.",
      "Un tiempo corto a solas — sin publicar, sin compartir."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cambiar el lenguaje interno",
    opening: localizedGenderNode(
      [
      "Hoy cambio “deben aprobarme” por “me elijo”."
    ],
      [
      "Hoy cambio “deben aprobarme” por “me elijo”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué creencia antigua me dirige?\n[Escribe aquí]",
      "2. ¿Cómo suena en un lenguaje más sano y amable?\n[Escribe aquí]",
      "3. ¿Qué frase adopto esta semana?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué creencia antigua me dirige?\n[Escribe aquí]",
      "2. ¿Cómo suena en un lenguaje más sano y amable?\n[Escribe aquí]",
      "3. ¿Qué frase adopto esta semana?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El lenguaje crea realidad.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "El lenguaje crea realidad.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Uso la frase nueva una vez.",
      "Uso la frase nueva una vez."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Elegir una dirección interna",
    opening: localizedGenderNode(
      [
      "Hoy defino dirección, no reacción."
    ],
      [
      "Hoy defino dirección, no reacción."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué valor es más importante que la aprobación?\n[Escribe aquí]",
      "2. ¿Cómo se expresa en una conducta pequeña?\n[Escribe aquí]",
      "3. ¿Qué me prometo en momentos de duda?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué valor es más importante que la aprobación?\n[Escribe aquí]",
      "2. ¿Cómo se expresa en una conducta pequeña?\n[Escribe aquí]",
      "3. ¿Qué me prometo en momentos de duda?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una dirección interna es más fuerte que el ruido externo.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre",
      "Una dirección interna es más fuerte que el ruido externo.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción basada en el valor.",
      "Elijo una acción basada en el valor."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy termino con lealtad a mí."
    ],
      [
      "Hoy termino con lealtad a mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué cambió en mí en este camino?\n[Escribe aquí]",
      "2. ¿Qué quedó más claro sobre la aprobación?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué cambió en mí en este camino?\n[Escribe aquí]",
      "2. ¿Qué quedó más claro sobre la aprobación?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del camino",
      "Puedo escuchar a otros",
      "sin abandonarme.",
      "Sigo caminando",
      "con mi propia voz.",
      "Y eso es fuerza.",
      "Pequeña acción para hoy"
    ],
      [
      "Cierre final del camino",
      "Puedo escuchar a otros",
      "sin abandonarme.",
      "Sigo caminando",
      "con mi propia voz.",
      "Y eso es fuerza.",
      "Pequeña acción para hoy"
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice: “Estoy de mi lado”.",
      "Una acción que simbolice: “Estoy de mi lado”."
    ),
  },
].map(buildNormalizedDay);

export const dependenceOnExternalApprovalBlueprintEs = buildNormalizedPilotBlueprint({
  id: "dependence_on_external_approval_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "dependence_on_external_approval",
  category: "general",
  journeyName: {
    he: "תלות באישור מבחוץ",
    en: "Dependence on External Approval",
    es: "Dependencia de la Aprobación Externa",
  },
  days,
});

export default dependenceOnExternalApprovalBlueprintEs;
